import styled from 'styled-components/macro';
import SimpleButton from 'styled/Buttons/SimpleButton';

const CloseButton = styled(SimpleButton)`
  position: absolute;
  top: 0;
  right: 0;
  color: #fff;
  opacity: 0.6;
  transition: opacity 0.15s ease-out;

  &:hover,
  &:focus {
    opacity: 1;
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

export default CloseButton;
